import { axiosAdminUserAccount } from '@/lib/axiosAdminUserAccount';
import { AuthUser } from '../types';

export const getUser = async (): Promise<AuthUser> => {
  return (await axiosAdminUserAccount.get<AuthUser>('/api/v/1/user/info')).data;
};
